import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useUser } from "./useUser";

export function useAuth() {
  const { user } = useUser();
  const navigate = useNavigate();

  const logout = useCallback(() => {
    navigate("/login?act=logout", { replace: true });
  }, [navigate]);

  return {
    isAuthenticated: user !== null,
    isAuthorized: user !== null,
    user,
    logout,
  };
}
